import {CallApi} from "./ApiCommon";
import {HomeDomain} from "./Config";
import {DisplayDesignItem} from "./response/DisplayDesign";
import {ApiRequestError} from "./ApiRequestError";

export const GetDisplayDesignList = async () => {
  try {
    const result = await CallApi(`https://${HomeDomain}/api_baby/display_list`, {
      credentials: "include"
    })
    return result.data.ownedItems as DisplayDesignItem[]
  } catch (e: any) {
    throw new ApiRequestError(e.message)
  }
}

export const PostDisplayDesign = async (item: DisplayDesignItem) => {
  try {
    const result = await CallApi(`https://${HomeDomain}/api_baby/display`, {
      credentials: "include",
      method: "POST",
      body: JSON.stringify(item)
    })
    return result.data as DisplayDesignItem
  } catch (e: any) {
    throw new ApiRequestError(e.message)
  }
}

export const DeleteDisplayDesign = async (displayId: string) => {
  try {
    await CallApi(`https://${HomeDomain}/api_baby/display?id=${displayId}`, {
      credentials: "include",
      method: "DELETE"
    })
  } catch (e: any) {
    throw new ApiRequestError(e.message)
  }
}